import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

import { CompaniesService } from "../../../services/companies.service";
import { CompanyProducts } from "src/models/phoenix/globalTypes";
import { CompaniesEnabled, Way2VatStorage } from "./apai-enabled.service";

@Injectable({
  providedIn: "root",
})
export class EinvoicingEnabledService {
  enabledCompaniesSubject = new ReplaySubject<CompaniesEnabled>();
  enabledCompanies$ = this.enabledCompaniesSubject.asObservable();
  enabledCompanies: CompaniesEnabled;

  constructor(private companiesService: CompaniesService) {}

  fetchConfig() {
    const way2vatData = this.getWay2VatData();

    if (!way2vatData) {
      console.warn("No way2vat data found in local storage");
      return;
    }

    const { payload } = way2vatData;
    const companiesIds = payload.companiesIds || [];
    const enabledProducts = payload.enabledProducts || {};
    const isAdmin = payload.role === "admin";

    if (payload.userId) {
      const entry = localStorage.getItem(
        "einvoicing_enabled_companies" + payload.userId,
      );

      if (entry) {
        try {
          const parsed: CompaniesEnabled = JSON.parse(entry);
          this.enabledCompanies = parsed;

          this.enabledCompaniesSubject.next(parsed);
        } catch (_) {
          console.error("Error parsing stored E-Invoicing enabled companies data");
        }
      }
    }

    const einvoicingCompanyIndices = enabledProducts.einvoicing || [];
    const einvoicingCompanyIds = einvoicingCompanyIndices.map(
      (index) => companiesIds[index],
    );

    const companyIds = isAdmin ? [] : einvoicingCompanyIds;

    const sub = this.companiesService.companiesWithEnabledProducts(
      "einvoicing" as CompanyProducts,
      companyIds,
    );
    sub.subscribe({
      next: (companies) => {
        const enabledCompaniesData: CompaniesEnabled = {
          userId: Number(payload.userId),
          userRole: payload.role,
          companies,
        };

        this.enabledCompanies = enabledCompaniesData;
        this.enabledCompaniesSubject.next(enabledCompaniesData);

        localStorage.setItem(
          "einvoicing_enabled_companies" + payload.userId,
          JSON.stringify(enabledCompaniesData),
        );
      },
      error: (error) => {
        console.error(
          "Error fetching company enabled products (E-Invoicing):",
          error,
        );
      },
    });
    return sub;
  }

  private getWay2VatData(): Way2VatStorage | null {
    try {
      const data = localStorage.getItem("way2vat");
      if (!data) return null;

      const parsedData = JSON.parse(data);
      const access_token = localStorage.getItem("access_token");

      const token = access_token || parsedData.access_token;
      const jwtToken = JSON.parse(atob(token.split(".")[1]));

      const expires = jwtToken.exp * 1000;
      const currTime = Date.now();
      const isExpired = currTime >= expires;
      if (isExpired) return null;
      return parsedData;
    } catch (error) {
      console.error("Error parsing way2vat data from local storage:", error);
      return null;
    }
  }
}
